import { render, staticRenderFns } from "./AlertaErro.vue?vue&type=template&id=d7cbe338"
import script from "./AlertaErro.vue?vue&type=script&lang=js"
export * from "./AlertaErro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports